export const actionTypes = {
  SET: `ACCOUNT_SET`,
  UNSET: `ACCOUNT_UNSET`,
}

const initState = {}

export default function accountReducer(state = initState, action) {
  switch (action.type) {
    case actionTypes.SET:
      return { ...action.payload }
    case actionTypes.UNSET:
      return { ...initState }
    default:
      return state
  }
}
